import config from '../config';
export async function enviarCorreo(formCorreo) {
  try {
    const response = await fetch(`${config.apiBaseUrl}/envio_correos.php`, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formCorreo),
    });

    const text = await response.text();
    if (!response.ok || !text) throw new Error("Respuesta inválida del servidor");

    const data = JSON.parse(text);
    return data;
  } catch (error) {
    console.error("❌ Error al enviar correo:", error);
    throw error;
  }
}
